import { SubscriptionFeature } from "../../../types/billing/SubscriptionFeature";

export const evalFeatures: SubscriptionFeature[] = [
    SubscriptionFeature.CanViewEvalData,
    SubscriptionFeature.CanExportEvalData,
]